import { getAuthHeaders } from '../actions/authActions';
import tempMeeApi from '../apis/tempMee';

export const getChallenges = async ({ status, limit, page } = {}) => {
  const headers = await getAuthHeaders();

  return tempMeeApi.get('metrics-service/admin/professional-loyalty/challenges', {
    headers,
    params: {
      status,
      limit: limit || 20,
      page,
    },
  });
};

export const postChallenge = async (data = {}) => {
  const headers = await getAuthHeaders();

  return tempMeeApi.post('metrics-service/admin/professional-loyalty/challenges', data, {
    headers,
  });
};

export const cancelChallenge = async (id) => {
  const headers = await getAuthHeaders();

  return tempMeeApi.delete(`metrics-service/admin/professional-loyalty/challenges/${id}`, {
    headers,
  });
};

export const getProfChallenges = async ({ profId, status, limit, page } = {}) => {
  const headers = await getAuthHeaders();

  return tempMeeApi.get(`metrics-service/admin/professional-loyalty/${profId}/challenges`, {
    headers,
    params: {
      status,
      limit: limit || 20,
      page,
    },
  });
};